var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileTopHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 380,
    height: 24,
    viewBox: "0 0 361 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37845",
    "data-name": "Group 37845",
    transform: "translate(-3341.202 -13896)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Layer_27",
    "data-name": "Layer 27",
    width: 361,
    height: 24,
    transform: "translate(3341.202 13896)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "status_nar",
    "data-name": "status nar",
    transform: "translate(3338.222 13898.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape_72",
    "data-name": "Shape 72",
    transform: "translate(10.98 4.993)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Layer_1",
    "data-name": "Layer 1",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Color_Overlay",
    "data-name": "Color Overlay",
    d: "M0,2.275a9.423,9.423,0,0,1,11.31,0L5.656,9.815ZM9,3.783l.942-1.272a8.395,8.395,0,0,0-8.577,0l.942,1.272A6.7,6.7,0,0,1,9,3.783ZM25.183,9.641V2.512L26.72,1.046v8.6Zm-2.3,0V4.712l1.669-1.593V9.641Zm-2.253,0V6.86l1.616-1.542V9.641Zm-2.915,0,2.279-2.174V9.641Zm17.275,0V1.257h1.886V0h2.515V1.257h1.886V9.639Zm30.95-2.395-.011-.111h.951l.022.111a1.536,1.536,0,0,0,1.6,1.43,1.619,1.619,0,0,0,1.671-1.818c0-1.153-.608-1.874-1.626-1.874a1.633,1.633,0,0,0-1.594,1.086h-.907l.531-4.445h4.338V2.4H67.352l-.343,2.66.475-.509a2.2,2.2,0,0,1,1.206-.321A2.363,2.363,0,0,1,71.235,6.79a2.592,2.592,0,0,1-2.722,2.639A2.277,2.277,0,0,1,65.935,7.244ZM56.85,8.718a.708.708,0,1,1,.707.71A.686.686,0,0,1,56.85,8.718Zm6.174.554V7.344H59.24V6.867l3.785-5.243h.951V6.567h.963v.777h-.963V9.273Zm-.631-5.4L60.446,6.567h2.579V2.9C62.847,3.2,62.648,3.519,62.393,3.875Zm-11.707,5.4V8.73L53.452,5.9c.9-.92,1.327-1.474,1.327-2.217a1.336,1.336,0,0,0-1.372-1.463c-.985,0-1.461.61-1.571,1.686l-.011.111h-.952l.012-.111a2.436,2.436,0,0,1,2.633-2.439,2.076,2.076,0,0,1,2.324,2.106c0,1.042-.564,1.751-1.859,3.026L52.069,8.5h3.74v.776Zm-3.542,0V2.633l-2.1,1.253V2.876l1.616-1.009a1.475,1.475,0,0,1,.83-.244H48.1V9.273ZM56.85,3.952a.708.708,0,1,1,1.416,0,.708.708,0,1,1-1.416,0Z",
    transform: "translate(275.087 6)",
    fill: "#6a6a6a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileTopHeader);
export default __webpack_public_path__ + "static/media/MobileTopHeader.8fc8a249.svg";
export { ForwardRef as ReactComponent };